import { StateCreator } from 'zustand'
import { AIPostType } from '@/shared/types'
import { CampaignCreationState } from '../state'

type SelectedAiPostsType = Record<number, boolean>

export interface Step6Slice {
    aiPosts: AIPostType[]
    selectedAiPosts: SelectedAiPostsType
    setAiPosts: (aiPosts: AIPostType[]) => void
    setSelectedAiPosts: (
        selectedAiPosts:
            | SelectedAiPostsType
            | ((prev: SelectedAiPostsType) => SelectedAiPostsType)
    ) => void
}

export const createStep6Slice: StateCreator<
    CampaignCreationState,
    [],
    [],
    Step6Slice
> = (set) => ({
    aiPosts: [],
    selectedAiPosts: {},
    setAiPosts: (aiPosts) => set({ aiPosts }),
    setSelectedAiPosts: (selectedAiPosts) =>
        set((state) => ({
            selectedAiPosts:
                typeof selectedAiPosts === 'function'
                    ? selectedAiPosts(state.selectedAiPosts)
                    : selectedAiPosts,
        })),
})
